<app-header [label]="page_name"></app-header>

<!-- Dropdown Filters -->
<div class="bg-white px-6 py-4 flex items-center gap-3 border-b border-gray-100">
    @if (!is_view_only) {
    <app-select-input label="University" [is_disabled]="gs.access_scope.locked.university" class="flex-1" [options]="university_options" [(ngModel)]="params.university_id" (ngModelChange)="on_university_change()"></app-select-input>
    }
    <app-select-input label="Academic Year" class="flex-1" [options]="filtered_academic_years" [(ngModel)]="params.academic_year_id" (ngModelChange)="on_academic_year_change()"></app-select-input>
    <app-select-input label="Exam Name" class="flex-1" [options]="filtered_exams" [(ngModel)]="params.exam_id" (ngModelChange)="on_exam_change()"></app-select-input>
    <app-select-input label="Subject Name" [is_disabled]="gs.access_scope.locked.subject" class="flex-1" [options]="filtered_subjects" [(ngModel)]="params.subject_id" (ngModelChange)="apply_filters()"></app-select-input>
</div>

<!-- Tabs + Search + Download -->
<div class="bg-white px-6 py-3 flex items-center gap-4 border-b border-gray-100">
    <!-- Status Tabs (admin only) -->
    @if (is_assigned_exceptions_page ? this.gs.user_role_data?.exceptions_assigned_exceptions_view : this.gs.user_role_data?.exceptions_exceptions_view) {
    <div class="inline-flex items-center border border-gray-200 rounded-xl">
        @for (tab of tabs; track tab.value; let last = $last) {
        <button (click)="set_tab(tab.value)" [class]="active_tab === tab.value
                ? 'relative z-10 -m-px bg-[#EAEBFF] text-[#3F41D1] px-8 py-2.5 text-sm font-medium tracking-wider border border-[#3F41D1] rounded-xl transition-all'
                : 'bg-transparent text-gray-400 px-8 py-2.5 text-sm font-medium tracking-wider transition-all hover:text-gray-500'">
            {{ tab.label }}&nbsp;&nbsp;({{ tab_counts[tab.value] || 0 }})
        </button>
        @if (!last) {
        <div class="h-5 w-px bg-gray-200 flex-shrink-0"></div>
        }
        }
    </div>
    }

    <div class="flex items-center gap-3 ml-auto">
        <app-search-input [placeholder]="is_view_only ? 'Search here...' : 'Search here...'" (valueChange)="get_list({ search: $event, page: 1 })"></app-search-input>
        <button (click)="download()" class="w-[50px] h-10 flex items-center justify-center rounded-full border border-[#3F41D1] text-[#3F41D1] transition-colors flex-shrink-0">
            <i class="bx bx-download text-xl"></i>
        </button>
    </div>
</div>

<!-- Table -->
<app-ag-grid-list [list]="items" [colDefs]="columns" [show_checkboxes]="false" [itemName]="page_name" height="calc(100vh - 180px)" [rowHeight]="60" (fetch_new_list)="get_list($event)"></app-ag-grid-list>